import axios from "axios";
import CoreService from "./core.service";

axios.defaults.withCredentials = true;


const getAllProvinces = () =>
    axios.get(`${CoreService.getPrivateURL()}provinces/`);
const getProvinces = (country_id) =>
    axios.get(`${CoreService.getPrivateURL()}provinces/${country_id.toString()}`);
const insertProvince = (country_id, province, abbreviation) =>
    axios.post(`${CoreService.getPrivateURL()}provinces/`, {country_id, province, abbreviation});
const removeProvince = (province_id) =>
    axios.delete(`${CoreService.getPrivateURL()}provinces/${province_id.toString()}`);
const getAllCities = () =>
    axios.get(`${CoreService.getPrivateURL()}cities/`);

const getCities = (province_id) =>
    axios.get(`${CoreService.getPrivateURL()}cities/${province_id.toString()}`);
const insertCity = (province_id, city) =>
    axios.post(`${CoreService.getPrivateURL()}cities/`, {province_id, city});
const removeCity = (city_id) =>
    axios.delete(`${CoreService.getPrivateURL()}cities/${city_id.toString()}`);

const getCountries = () =>
    axios.get(`${CoreService.getPrivateURL()}countries/`);
const insertCountry = (name, code, short_name) =>
    axios.post(`${CoreService.getPrivateURL()}countries/`, {name, code, short_name});
const removeCountry = (country_id) =>
    axios.delete(`${CoreService.getPrivateURL()}countries/${country_id.toString()}`);

const getCurrencies = () =>
    axios.get(`${CoreService.getPrivateURL()}currencies/`);
const insertCurrency = (name) =>
    axios.post(`${CoreService.getPrivateURL()}currencies/`, {name});
const removeCurrency = (country_id) =>
    axios.delete(`${CoreService.getPrivateURL()}currencies/${country_id.toString()}`);


const getHolidays = () =>
    axios.get(`${CoreService.getPrivateURL()}holidays/`);
const insertHoliday = (holiday_date, holiday_name) =>
    axios.post(`${CoreService.getPrivateURL()}holidays/`, {holiday_date, holiday_name});
const removeHoliday = (holiday_id) =>
    axios.delete(`${CoreService.getPrivateURL()}holidays/${holiday_id.toString()}`);




const getClosures = () =>
    axios.get(`${CoreService.getPrivateURL()}closures/`);
const insertClosure = (data) =>
    axios.post(`${CoreService.getPrivateURL()}closures/`, data, {withCredentials:true});
const updateClosure = (closure_id, data) =>
    axios.put(`${CoreService.getPrivateURL()}closures/${closure_id.toString()}`, data, {withCredentials:true});
const updateClosureStatus = (closure_id, status) =>
    axios.post(`${CoreService.getPrivateURL()}closures/${closure_id.toString()}/status`, {status}, {withCredentials:true});
const removeClosure = (closure_id) =>
    axios.delete(`${CoreService.getPrivateURL()}closures/${closure_id.toString()}`);






const CustomService = {
  getCountries,
  insertCountry,
  removeCountry,

  getCurrencies,
  insertCurrency,
  removeCurrency,

  getAllProvinces,
  getCities,
  insertCity,
  removeCity,

  getAllCities,
  getProvinces,
  insertProvince,
  removeProvince,

  getHolidays,
  insertHoliday,
  removeHoliday,

  getClosures,
  insertClosure,
  updateClosure,
  updateClosureStatus,
  removeClosure,


};
export default CustomService;
